export const loaderConstants = {
    ACTIVE: 'LOADER_ACTIVE',
    INACTIVE: 'LOADER_INACTIVE',
    GET_PUBLIC_CONFIG: 'GET_PUBLIC_CONFIG'
};
